import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var BulkHttpService = /** @class */ (function () {
    function BulkHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    BulkHttpService.prototype.getRegions = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-regions';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    BulkHttpService.prototype.getStageStatus = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/stage-status';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                console.log(response);
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    BulkHttpService.prototype.getTerritories = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-territories';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    BulkHttpService.prototype.getVersions = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_versions';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    // getMachines(queryParams) {
    // 	return new Observable((observer: any) => {
    // 		const path = '/dashboard/get_all_macs';
    // 		const myInit = {
    // 			response: false,
    // 			queryStringParameters: queryParams
    // 		};
    // 		API.get(this.apiName, path, myInit).then(response => {
    // 		  observer.next(response.data);
    // 		}).catch(err => {
    // 			console.log(err.response);
    // 			observer.error(err);
    // 		});
    // 	});
    // }
    BulkHttpService.prototype.getAllVersions = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_all_macs_version';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    BulkHttpService.prototype.assignBulkUpdates = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/bulk-update';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    BulkHttpService.prototype.updateMacCategory = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/update-mac-category';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    BulkHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BulkHttpService_Factory() { return new BulkHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: BulkHttpService, providedIn: "root" });
    return BulkHttpService;
}());
export { BulkHttpService };
